import {
  isMobile as isRealMobile,
  isMobileOnly as isRealMobileOnly,
  isTablet as isRealTablet,
  osVersion,
  isIOS,
} from "react-device-detect";

export const useDeviceDetect = () => {
  return {
    isIOS,
    isRealMobile,
    isRealTablet,
    isRealMobileOnly,
    isRealMobileOrTablet: isRealMobile || isRealTablet,
    osVersion
  };
};
